import { Component, EventEmitter, Output } from '@angular/core';
import { UserBoardTypes } from 'src/app/services/models/user-board.model';

@Component({
  selector: 'bhub-board-type-selector',
  templateUrl: './board-type-selector.component.html',
  styles: `
    .board-type-selector {
      padding: 20px;
    }

    .selector-header {
      text-align: center;
      margin-bottom: 30px;
    }

    .board-type-cards {
      display: flex;
      gap: 20px;
      justify-content: center;
      flex-wrap: wrap;
    }

    .board-type-card {
      width: 300px;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s;
    }

    .board-type-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    }

    .board-type-card.disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .board-type-card.disabled:hover {
      transform: none;
      box-shadow: none;
    }

    .card-icon {
      font-size: 48px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1976d2;
    }

    .coming-soon-badge {
      background-color: #ff9800;
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 12px;
      margin-left: 10px;
    }
  `,
  standalone: false
})
export class BoardTypeSelectorComponent {
  @Output() boardTypeSelected = new EventEmitter<UserBoardTypes>();
  @Output() cancelSelection = new EventEmitter<void>();

  boardTypes = UserBoardTypes;

  boardTypeOptions = [
    {
      value: UserBoardTypes.TileBoard,
      label: 'Tile Board',
      description: 'Create a dashboard with customizable tiles for data visualization',
      icon: 'dashboard',
      available: true
    },
    {
      value: UserBoardTypes.SpreadsheetBoard,
      label: 'Spreadsheet Board',
      description: 'Create a spreadsheet-style board for tabular data management',
      icon: 'table_chart',
      available: true
    }
  ];

  selectBoardType(boardType: UserBoardTypes, available: boolean): void {
    if (available) {
      this.boardTypeSelected.emit(boardType);
    }
  }

  cancel(): void {
    this.cancelSelection.emit();
  }
}